import { Component, Prop, h, Element, Watch, Fragment } from "@stencil/core"
import { Login } from "../header/types"
import {
  getAppearance,
  parseJson,
  translate,
} from "../../core/helpers/webcomponent-helpers"
import { getLoginStatus, createLink } from "../header/helpers"

@Component({
  tag: "sdx-login-menu",
  styleUrl: "login-menu.scss",
  shadow: true,
})
export class LoginMenu {
  @Element() public el!: HTMLSdxLoginMenuElement

  private loginParsed?: Login

  @Prop() public login?: Login | string

  @Watch("login")
  public loginChanged() {
    this.loginParsed = parseJson(this.login)
  }

  constructor() {
    this.loginParsed = parseJson(this.login)
  }

  private getComponentClassNames() {
    return {
      component: true,
      [getAppearance(this.el)]: true,
    }
  }

  private getWelcomeMessage() {
    const now = new Date()
    const time = now.getHours()

    let welcomeMessage

    if (time >= 0 && time < 12) {
      welcomeMessage = "Good morning"
    } else if (time >= 12 && time < 18) {
      welcomeMessage = "Good afternoon"
    } else {
      welcomeMessage = "Good evening"
    }

    return welcomeMessage
  }

  public render() {
    const { isLoggedIn, initials } = getLoginStatus(this.loginParsed)

    return (
      <div class={this.getComponentClassNames()}>
        {isLoggedIn && (
          <div class="heading">
            <span class="initials">{initials}</span>

            <div class="salutation">
              <div class="h5">
                {translate(this.getWelcomeMessage(), this.el.lang)}
                <br />
                {this.loginParsed?.customer?.fullName}
              </div>
            </div>
          </div>
        )}

        {createLink(
          {
            ...(isLoggedIn
              ? this.loginParsed?.logout
              : this.loginParsed?.login),
            label: isLoggedIn
              ? translate("Logout", this.el.lang)
              : translate("Login", this.el.lang),
          },
          {
            class: {
              button: true,
              "button--full": true,
              "button--secondary": isLoggedIn,
            },
          },
        )}

        {this.loginParsed?.children?.map((item) => (
          <Fragment>
            <div class="divider horizontal">
              <span class="divider-label">{item.label}</span>
            </div>

            <ul class="ul vertical links">
              {item.children?.map((child) => (
                <li class="item">{createLink(child)}</li>
              ))}
            </ul>
          </Fragment>
        ))}
      </div>
    )
  }
}
